import { EventEmitter } from '@angular/core';
import { DEFAULT_SAVED_ASSET_OPTIONS_CHOICES } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-saved-asset-options/interfaces/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = a0 => ({ list: a0 });
const _c1 = () => ({ button: "btn btn-secondary btn-block style-underline" });
function CustomPdfReportSavedAssetOptions_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "ycn-single-select-dropdown", 5);
    i0.ɵɵlistener("changeHandler", function CustomPdfReportSavedAssetOptions_div_0_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { const field_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateSavedAssetSecuritiesChoice(field_r2, $event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const field_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.dropdownsFieldChoices[field_r2].label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", i0.ɵɵpureFunction1(4, _c0, ctx_r2.dropdownsFieldChoices[field_r2].choices))("customCssClasses", i0.ɵɵpureFunction0(6, _c1))("selectedValue", ctx_r2.currentValues[field_r2]);
} }
/**
 * Saved Asset Options Component
 *
 * Displays a set of options with a dropdown value to set the security configurations
 * saved assets.
 *
 * Inputs:
 * savedAssetSecuritiesFields: which saved asset options to show.
 * dropdownsFieldChoices: what options are available for each saved asset field.
 *
 * Output:
 *  updateFieldChoice: emits a new configuration for a saved asset option
 */
export class CustomPdfReportSavedAssetOptions {
    constructor() {
        this.currentValues = DEFAULT_SAVED_ASSET_OPTIONS_CHOICES;
        this.savedAssetSecuritiesFields = [];
        this.updateFieldChoice = new EventEmitter();
    }
    updateSavedAssetSecuritiesChoice(field, choice) {
        this.currentValues = { [field]: choice, ...this.currentValues };
        this.updateFieldChoice.emit({ field, choice });
    }
}
CustomPdfReportSavedAssetOptions.ɵfac = function CustomPdfReportSavedAssetOptions_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPdfReportSavedAssetOptions)(); };
CustomPdfReportSavedAssetOptions.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPdfReportSavedAssetOptions, selectors: [["ycn-custom-pdf-report-saved-asset-options"]], inputs: { currentValues: "currentValues", savedAssetSecuritiesFields: "savedAssetSecuritiesFields", dropdownsFieldChoices: "dropdownsFieldChoices" }, outputs: { updateFieldChoice: "updateFieldChoice" }, standalone: false, decls: 1, vars: 1, consts: [["class", "row mb-row", 4, "ngFor", "ngForOf"], [1, "row", "mb-row"], [1, "col-4"], [1, "form-label", "form-label-thin", 3, "textContent"], [1, "col-8"], [1, "dropdown", 3, "changeHandler", "config", "customCssClasses", "selectedValue"]], template: function CustomPdfReportSavedAssetOptions_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomPdfReportSavedAssetOptions_div_0_Template, 5, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.savedAssetSecuritiesFields);
    } }, dependencies: [i1.NgForOf, i2.SingleSelectDropdownComponent], encapsulation: 2 });
